import { productUrlPrefix } from './url-utils';

export const createGameOrderUrl = ({ gameId, product = 'waybetter' }) =>
  `${productUrlPrefix(product)}/games/${gameId}/join`;
